export const lowerCaseFirstLetter = (input: string) => {
  return input[0].toLowerCase() + input.substring(1);
};
